import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor();

export default {
  getEspecialidades(){
    return api.get(`especialidades/`)
  }
}
